import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkboxContainer"];

  checkAll() {
    this.setAllCheckboxes(true);
  }

  uncheckAll() {
    this.setAllCheckboxes(false);
  }

  setAllCheckboxes(checkedState) {
    const checkboxes = this.checkboxContainerTarget.querySelectorAll(
      'input[type="checkbox"]'
    );

    checkboxes.forEach((checkbox) => {
      checkbox.checked = checkedState;
    });
  }
}
